import React from 'react';
import { Button, Modal, Space } from 'antd';
import './CustomModal.scss';

interface CustomModalProps {
  isModalOpen: boolean;
  onOk: () => void;
  onCancel: () => void;
  title?: string;
  okText?: string;
  cancelText?: string;
  footerContent?: React.ReactNode;
  children?: React.ReactNode;
  isLoading?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
  isModalOpen,
  onOk,
  onCancel,
  title = '',
  okText = 'OK',
  cancelText = 'Cancel',
  footerContent,
  children,
  isLoading,
}) => {
  const modalFooter = (
    <div className="modal-footer">
      <Space>
        <Button className="cancel-btn" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button loading={isLoading} className="ok-btn" key="ok" onClick={onOk} type="primary">
          {okText}
        </Button>
      </Space>
    </div>
  );

  return (
    <Modal title={title} open={isModalOpen} onOk={onOk} onCancel={onCancel} footer={footerContent || modalFooter} centered width={700}>
      {children}
    </Modal>
  );
};

export default CustomModal;
